import React, { useRef, useEffect, useState, memo } from 'react';

import PropTypes from 'prop-types';
import { produce } from 'immer';
import { useSelector } from 'react-redux';

import Chart from './solidgaugeChart';

import {
  defaultSentimentChartOption,
  // sentimentColors as colors,
} from './config';

const titles = {
  networkSecurity: 'Network Security',
  dnsHealth: 'DNS Health',
  patchingCadence: 'Patching Cadence',
  endpointSecurity: 'Endpoint Security',
  ipReputation: 'IP Reputation',
  applicationSecurity: 'Application Security',
  cubitScore: 'Cubit Score',
  hackerChatter: 'Hacker Chatter',
  leakedInformation: 'Information Leak',
  socialEngineering: 'Social Engineering',
};

export const reflowChart = (...charts) => {
  try {
    charts.forEach((chart) => {
      if (chart && chart.current && chart.current.chart.reflow) {
        chart.current.chart.reflow();
      }
    });
  } catch (error) {
    console.error(error);
  }
};

export const destroyCharts = (...charts) => {
  try {
    charts.forEach((chart) => {
      chart &&
        chart.current &&
        chart.current.destroy &&
        chart.current.destroy();
    });
  } catch (error) {
    console.error(error);
  }
};

function CyberChart({ data }) {
  const chartRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const { buyerLabel, targetLabel } = useSelector(({ common }) => ({
    buyerLabel: common.projectCompanyInfo.buyerLabel,
    targetLabel: common.projectCompanyInfo.targetLabel,
  }));

  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!data) {
      return;
    }
    const { buyer, target } = data;
    const datas = [];
    buyer &&
      Object.keys(titles).forEach((item, idx) => {
        datas[idx] = {
          buyer: buyer[item].score,
          target: target[item].score,
          title: titles[item],
        };
      });
    const newOptions = [];
    datas.forEach((item, index) => {
      const options = produce(defaultSentimentChartOption, (draft) => {
        // draft.title.text = item.title;
        draft.series[0].name = buyerLabel;
        draft.series[1].name = targetLabel;

        if (item.buyer) {
          draft.series[1].data[0].y = item.buyer;
        } else {
          draft.series[1].data[0].y = 0;
          draft.series[1].data[0].dataLabels.format =
            '<span style="font-size:0.75rem!important;">Buyer   </span><span style="font-size:1.25rem!important;font-weight:bold!important;"> N/A</span>';

          draft.series[1].data[0].color = '#303030';
        }
        if (item.target) {
          draft.series[0].data[0].y = item.target;
        } else {
          draft.series[0].data[0].y = 0;
          draft.series[0].data[0].dataLabels.format =
            '<span style="font-size:0.75rem!important;">Target </span><span style="font-size:1.25rem!important;font-weight:bold!important;">  N/A</span>';

          draft.series[0].data[0].color = '#303030';
        }
      });
      newOptions.push(options);
    });

    setOptions(newOptions);
  }, [data, buyerLabel]);

  useEffect(() => {
    if (options.length !== 0) {
      reflowChart(...chartRefs);
    }
  }, [options]);

  return (
    <>
      <div className="cyber-right-top">
        <div className="title">Security Ratings</div>
        <div className="cyber-right-chart">
          {options?.map((item, index) => (
            <div className="single-cyber-chart" key={index}>
              <div className="single-title">{Object.values(titles)[index]}</div>
              <Chart ref={chartRefs[index]} options={options[index]} />
            </div>
          ))}
        </div>
      </div>{' '}
      <div className="cyber-right-footer">Source: SecurityScorecard</div>
    </>
  );
}

CyberChart.propTypes = {
  data: PropTypes.object.isRequired,
};

export default memo(CyberChart);
